/* Build your own bundle - the builder behind /pages/build-your-own-bundle.
   Lives here rather than inline in the snippet so the copy and the maths can
   be edited without rewriting the page markup. */
(function(){
  /* min units -> what we advertise, and which bundle variant delivers it.
     adv is the headline number, measured against the dashed price. k picks
     the data-v / data-p pair on each card, which carry that tier's variant
     id and its price straight from Shopify. */
  var TIERS=[{min:5,adv:35,k:'5'},
             {min:4,adv:25,k:'4'},
             {min:3,adv:20,k:'3'}];
  var cards=[].slice.call(document.querySelectorAll('[data-byo]'));
  if(!cards.length) return;
  var panel=document.getElementById('byoPanel'), lines=document.getElementById('byoLines'),
      foot=document.getElementById('byoFoot'), go=document.getElementById('byoGo'),
      close=document.getElementById('byoClose'), count=document.getElementById('byoCount');
  var state={};   /* what is in the bundle */
  var pend={};    /* what the stepper is sitting on before it is added */
  var hidden=false;

  /* Coming back from "edit bundle" in the cart: those lines were lifted out
     of the cart and parked here, so the builder reopens holding them. */
  try{
    var pre=sessionStorage.getItem('byoEdit');
    if(pre){ sessionStorage.removeItem('byoEdit'); state=JSON.parse(pre)||{}; }
  }catch(e){ state={}; }

  /* No thousands separator - nothing here reaches $1,000 - which also keeps
     this file free of backslashes, since the theme API mangles them. */
  /* The currency suffix is wrapped so the phone layout can drop it from the
     line prices alone. Two of them per line - struck and paid - is what used
     to push the product name past the edge of the panel and have it cut off
     with an ellipsis. The total and the saving still carry it, and so does
     every price on desktop, where there is room. */
  function money(c){ return '$'+(c/100).toFixed(2)+'<span class="byo__cur"> AUD</span>'; }
  function tierFor(n){ for(var i=0;i<TIERS.length;i++){ if(n>=TIERS[i].min) return TIERS[i]; } return null; }
  function nextTier(n){ var b=null; for(var i=0;i<TIERS.length;i++){ if(n<TIERS[i].min&&(!b||TIERS[i].min<b.min)) b=TIERS[i]; } return b; }
  function units(){ var n=0; for(var k in state) n+=state[k]; return n; }

  /* The list shows five products and half of a sixth, and scrolls past that.

     The height is measured off the rendered rows rather than written down,
     because a row is not a fixed thing. On a phone every line is one line of
     37.4px. On desktop the full product title wraps and a row is 65px with a
     two-line title or 89px with a three-line one, so five products are 327px
     or 443px depending on which five. A number in the stylesheet would stop
     meaning five the first time a title, a font or a padding changed.

     The half row is the point of it. A list cut cleanly after the fifth looks
     like the whole bundle; half a row showing is the only thing that says it
     carries on, and the count in the header is the only other clue.

     Measured twice. Applying the cap can bring up a scrollbar, and on a
     platform that gives the scrollbar its own width that narrows the rows and
     re-wraps the titles; the second pass reads them where they finally sit.
     Fewer than six products need no cap at all. */
  function cap(){
    if(lines.children.length<6){ lines.style.maxHeight=''; lines.style.overflowY=''; return; }
    lines.style.maxHeight='';
    lines.style.overflowY='auto';
    for(var i=0;i<2;i++){
      var rows=lines.children;
      lines.style.maxHeight=Math.round(rows[5].offsetTop-rows[0].offsetTop+rows[5].offsetHeight/2)+'px';
    }
  }
  /* Rotating a phone or dragging a window edge re-wraps the titles, so the
     measurement has to be taken again. */
  window.addEventListener('resize', cap);
  var TRASH='<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" aria-hidden="true"><path d="M4 7h16M10 11v6M14 11v6M6 7l1 13h10l1-13M9 7V4h6v3"/></svg>';

  function render(){
    var n=units(), t=tierFor(n), k=t?t.k:null, paid=0, was=0, html='';
    cards.forEach(function(c){
      var h=c.getAttribute('data-byo'), q=state[h]||0;
      c.classList.toggle('byo--on', q>0);
      /* the stepper shows the bundle quantity once it is in, otherwise
         whatever the customer has dialled up ready to add */
      c.querySelector('[data-byoqty]').textContent = q>0 ? q : (pend[h]||1);
      var add=c.querySelector('[data-byoadd]');
      add.textContent = q>0 ? 'Remove' : 'Add to bundle';
      if(!q) return;
      var now=+c.getAttribute('data-now'), w=+c.getAttribute('data-was');
      /* No arithmetic. The bundle price is a real price on a real variant, so
         this reads it off the card and the panel can never drift from what
         Shopify charges. Below three items there is no tier and the product
         sits at its normal price. */
      var unit=k ? (+c.getAttribute('data-p'+k) || now) : now;
      var lp=unit*q;
      paid+=lp; was+=w*q;
      /* Both names go into the markup and CSS picks one. The full title is
         what the panel has always shown and is kept on desktop; the phone
         shows data-short, the same tail-of-the-title the cart prints, so a
         line fits on one line instead of wrapping to two. Doing it in CSS
         rather than here means a rotated phone or a resized window switches
         straight away, with no re-render. */
      html+='<div class="byo__line"><span class="byo__ln">'+q+'x '+
              '<span class="byo__nl">'+c.getAttribute('data-name')+'</span>'+
              '<span class="byo__ns">'+(c.getAttribute('data-short')||c.getAttribute('data-name'))+'</span></span>'+
            '<span class="byo__lp tab">'+(w>now?'<s>'+money(w*q)+'</s>':'')+'<b>'+money(lp)+'</b></span>'+
            '<button class="byo__del" type="button" data-del="'+h+'" aria-label="Remove '+c.getAttribute('data-name')+'">'+TRASH+'</button></div>';
    });
    lines.innerHTML = html || '<p class="byo__empty">Add any 3 products to start saving.</p>';
    lines.querySelectorAll('[data-del]').forEach(function(b){
      b.addEventListener('click',function(){ delete state[b.getAttribute('data-del')]; render(); });
    });
    cap();

    var save=was-paid, nx=nextTier(n), f='';
    count.textContent = n ? n+' item'+(n>1?'s':'')+(t?' · '+t.adv+'% off':'') : '';
    if(n){
      f+='<div class="byo__total"><span>Total</span><b class="tab">'+money(paid)+'</b></div>';
      var meta=[];
      if(t) meta.push('You save <b>'+money(save)+'</b>');
      if(nx){ var need=nx.min-n; meta.push('add '+(need===1?'one more product':need+' more products')+' for <b>'+nx.adv+'% off</b>'); }
      else if(t) meta.push('biggest saving unlocked');
      if(meta.length) f+='<p class="byo__meta">'+meta.join(' · ')+'</p>';
    }
    foot.innerHTML=f;

    go.disabled=!t;
    go.textContent = t ? 'Add bundle to cart' : (n ? 'Add '+(3-n)+' more to save' : 'Add bundle to cart');
    panel.classList.toggle('byo--active', n>0 && !hidden);
    document.querySelectorAll('.byo__tier').forEach(function(el){
      el.classList.toggle('on', !!t && +el.getAttribute('data-tiern')===t.min);
    });
  }

  /* Once a product is in the bundle the stepper edits the bundle directly.
     Before that it only moves the number the Add button will use. */
  function step(h,d){
    if(state[h]){ state[h]=state[h]+d; if(state[h]<1) delete state[h]; }
    else { pend[h]=Math.max(1,(pend[h]||1)+d); }
    hidden=false; render();
  }
  function toggle(h){
    if(state[h]) delete state[h];
    else state[h]=pend[h]||1;
    hidden=false; render();
  }
  cards.forEach(function(c){
    var h=c.getAttribute('data-byo');
    c.querySelector('[data-byoadd]').addEventListener('click',function(){ toggle(h); });
    c.querySelector('[data-byomore]').addEventListener('click',function(){ step(h,1); });
    c.querySelector('[data-byoless]').addEventListener('click',function(){ step(h,-1); });
  });
  close.addEventListener('click',function(){ hidden=true; render(); });

  go.addEventListener('click',function(){
    var t=tierFor(units()); if(!t) return;
    /* Two kinds of line property go on every item.

       _byo and _byon are for us: the stamp that lets the cart draw one bundle
       row instead of loose products, and the short name that row prints. The
       underscore keeps Shopify from showing them to the customer.

       "Original price" and "Discount" are for the customer. Nothing is
       discounted here - the bundle variant simply costs less - so Shopify
       shows no struck price and no discount pill, and these two lines are
       what tell the customer what they saved. Line properties print under
       the product name on every plan; adding real text to the checkout page
       would need Plus.

       They are written once, at add time, from the tier the bundle qualified
       for. That is safe here because the cart shows a bundle as one row with
       no quantity stepper - the only ways to change it are remove and edit
       bundle, and edit re-adds through this same function with fresh text. */
    var bid='byo-'+Date.now()+'-'+Math.floor(Math.random()*10000);
    var items=cards.filter(function(c){ return state[c.getAttribute('data-byo')]; })
      .map(function(c){
        var props={_byo:bid, _byon:c.getAttribute('data-short')||c.getAttribute('data-name')};
        props['Original price']='$'+(+c.getAttribute('data-was')/100).toFixed(2);
        props['Discount']=t.adv+'% OFF';
        return {id:+c.getAttribute('data-v'+t.k)||+c.getAttribute('data-id'),
                quantity:state[c.getAttribute('data-byo')], properties:props};
      });
    go.disabled=true; go.textContent='Adding...';
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},
      body:JSON.stringify({items:items})})
      .then(function(r){ if(!r.ok) throw 0; return r.json(); })
      .then(function(){
        /* Nothing to redeem. Shopify has already applied the automatic
           discount to the cart and re-checks the quantity on every change,
           so the drawer opens showing the discounted price straight away.
           The builder is emptied so a second click cannot double up. */
        state={}; pend={}; hidden=false; render();
        go.disabled=false; go.textContent='Add bundle to cart';
        if(window.toggleCart) window.toggleCart(true); else window.location.href='/cart';
        if(window.toast) window.toast('Bundle added to cart');
      })
      .catch(function(){ go.disabled=false; go.textContent='Add bundle to cart'; });
  });

  render();
})();